import { toCamelCase } from 'util/string-transform';

export const urlPrefix = 'work-orders';
export const queryKey = toCamelCase(urlPrefix);
